module.exports = __webpack_public_path__ + "static/media/s-img.6ec8ca98.svg";